var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBest = function SvgBest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#96bc4b",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-background"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.43a.5.5 0 0 0-.27.08.46.46 0 0 0-.17.22L7.24 7.17l-3.68.19a.5.5 0 0 0-.26.1.53.53 0 0 0-.16.23.45.45 0 0 0 0 .28.44.44 0 0 0 .15.23l2.86 2.32-1 3.56a.45.45 0 0 0 0 .28.46.46 0 0 0 .17.22.4.4 0 0 0 .26.09.43.43 0 0 0 .27-.08l3.09-2 3.09 2a.46.46 0 0 0 .53 0 .46.46 0 0 0 .17-.22.53.53 0 0 0 0-.28l-1-3.56 2.98-2.33a.44.44 0 0 0 .15-.2.45.45 0 0 0 0-.28.53.53 0 0 0-.16-.23.5.5 0 0 0-.26-.1l-3.68-.2-1.32-3.46a.46.46 0 0 0-.17-.22.5.5 0 0 0-.27-.08",
    className: "icon-component-shadow",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 2.93a.5.5 0 0 0-.27.07.46.46 0 0 0-.17.22L7.24 6.67l-3.68.19A.5.5 0 0 0 3.3 7a.53.53 0 0 0-.16.23.45.45 0 0 0 0 .28.44.44 0 0 0 .15.23L6.15 10l-1 3.56a.45.45 0 0 0 0 .28.46.46 0 0 0 .17.22.4.4 0 0 0 .26.09.43.43 0 0 0 .27-.08l3.09-2 3.09 2a.46.46 0 0 0 .53 0 .46.46 0 0 0 .17-.22.53.53 0 0 0 0-.28l-1-3.56 2.98-2.31a.44.44 0 0 0 .15-.23.45.45 0 0 0 0-.28.5.5 0 0 0-.16-.19.5.5 0 0 0-.26-.1l-3.68-.2-1.32-3.47A.46.46 0 0 0 9.27 3 .5.5 0 0 0 9 2.93",
    className: "icon-component"
  })));
};
export default SvgBest;